import {ilahiCatalogue as hymns,devotionalTexts as prayers,libraryCatalogue as library,publicLessons as lessons,catalogueDisplay as display} from './privateContent';
export const researchScope = 'Mahmut Efendim AI · Sohbetler ve Kütüphane';

const fold = value => String(value).toLocaleLowerCase('tr').replace(/ı/g,'i').normalize('NFD').replace(/[\u0300-\u036f\u064b-\u065f]/g,'').replace(/[^\p{L}\p{N}]+/gu,' ').trim();
const lines = verse => [...(verse.arabic||[]),...(verse.lines||[]),...(verse.transliteration||[]),...(verse.translation||[]),...(verse.items||[]).flatMap(item=>item.lines||[])];
// Only already-published assets. No local/private corpus or member records.
const records = () => [
 ...hymns.items.map(x=>({id:'hymn:'+x.id,title:x.title,text:x.text||'',type:'İlahiler',level:'Metin eşleşmesi',url:'/ilahiler?'+new URLSearchParams({eser:x.id}),source:'Sağlanan ilahi koleksiyonu'})),
 ...prayers.items.map(x=>({id:'prayer:'+x.id,title:x.title,text:x.verses.flatMap(lines).join('\n'),type:x.kind==='kaside'?'Kasideler':'Evrad & Zikâr',level:'Metin eşleşmesi',url:x.kind==='kaside'?'/kasideler':'/evrad-zikar',source:x.source_file})),
 ...library.items.map(x=>({id:'book:'+x.source_id,title:display[x.source_id]?.display_title || x.title.replace(/^\d+[-_]/,'').replace(/_/g,' '),text:'',type:'Kütüphane',level:'Katalog başlığı',url:'/kutuphane?'+new URLSearchParams({q:display[x.source_id]?.display_title||x.title.replace(/^\d+[-_]/,'').replace(/_/g,' ')}),source:'Son kayıtlı açık katalog · '+library.snapshot_date})),
 ...lessons.map(x=>({id:'lesson:'+x.id,title:x.title,text:x.speaker+' · '+x.source,type:'Sohbetler',level:'Yayın bilgisi',url:x.url,source:x.source}))
];

export function availablePublicRecords(scope='Tüm Kaynaklar') {
 return records().filter(x=>scope===researchScope?['Sohbetler','Kütüphane'].includes(x.type):scope==='Tüm Kaynaklar'||x.type===scope);
}
export function searchPublicSources(query,scope='Tüm Kaynaklar') {
 const words=fold(query).split(' ').filter(Boolean).slice(0,30);
 if(!words.length)return [];
 return availablePublicRecords(scope).map(x=>{
   const title=fold(x.title),text=fold(x.text),haystack=title+' '+text;
   const score=words.filter(word=>haystack.includes(word)).length;
   return {...x,score:score+words.filter(word=>title.includes(word)).length+(title===fold(query)?100:0),matched:score===words.length};
 }).filter(x=>x.matched).sort((a,b)=>b.score-a.score).slice(0,12).map(x=>{
   const position=Math.max(0,fold(x.text).indexOf(words[0])-80);
   return {...x,excerpt:x.text.slice(position,position+360)};
 });
}

// Only the authorised feed's ready transcript/text records may supply suggestions.
export function availableResearchRecords(scope=researchScope,items=[]) {
 const supported=['Sohbetler','Kütüphane'].includes(scope)?[scope]:['Sohbetler','Kütüphane'];
 return items.filter(x=>x?.text_ready===true&&supported.includes(x.type)&&typeof x.title==='string'&&x.title.trim()&&typeof x.url==='string'&&/^\/(soru-cevap|kutuphane)\?/.test(x.url));
}
export function exampleResearchRecords(items) {
 const seen=new Set(),talks=[],books=[];
 for(const x of items){const key=fold(x.topic||x.title);if(seen.has(key))continue;seen.add(key);(x.type==='Kütüphane'?books:talks).push(x);}
 const out=[];
 while(out.length<8&&(talks.length||books.length)){if(talks.length)out.push(talks.shift());if(books.length&&out.length<8)out.push(books.shift());}
 return out;
}

// The caller supplies only its current authorised feed; no private fallback.
export function searchResearchSources(query,{scope=researchScope,items=[],readyOnly=true,topic=''}={}) {
 if(![researchScope,'Sohbetler','Kütüphane'].includes(scope))return [];
 const prepared=availableResearchRecords(scope,items);
 const candidates=readyOnly?prepared:[...prepared,...availablePublicRecords(scope)];
 const words=fold(query).split(' ').filter(Boolean).slice(0,30),seen=new Set();
 return candidates.filter(record=>{
  if(seen.has(record.id))return false;seen.add(record.id);
  if(topic&&record.topic!==topic)return false;
  const haystack=fold([record.title,record.topic||'',record.source].join(' '));
  return words.every(word=>haystack.includes(word));
 });
}
